/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMarket.ts                        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/general/market";

export class AutogenModelMarket<RowType extends ModelRow> extends Endpoint<RowType, RowMarketFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowMarket extends ModelRow<RowMarketFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowMarketFields {
    company_id: string;
    descr: string;
    id: string;
}

